export default __webpack_public_path__ + "static/media/React-Component-LifeCycle.03c0c9f0.png";